import React from 'react';
import {Chart} from 'devextreme-react';
import {
  CommonAxisSettings,
  CommonSeriesSettings,
  Font,
  Label,
  Size,
} from 'devextreme-react/chart';
import {Tooltip} from 'devextreme-react/pie-chart';

const customPalette = ['#00B050', '#D0EEA9', '#FFFF00', '#FF0000'];

const BarChartKPI = ({dataSource, title, children}) => {
  return (
    <Chart
      id="chart"
      dataSource={dataSource}
      palette={customPalette}
      // commonAxisSettings={{color: 'black'}}
      theme="generic.light"
    >
      {/* <Title
        text={title}
        horizontalAlignment="center">
        <Font color="black" />
      </Title> */}

      <CommonAxisSettings>
        <Label rotationAngle={90} displayMode="rotate">
          <Font color="black" size={16} />
        </Label>
      </CommonAxisSettings>

      <CommonSeriesSettings
        id="series"
        argumentField="name"
        type="fullstackedbar"
        showInLegend={false}
      />

      {children}

      <Tooltip target="#series" enabled={true} opacity={1}>
        <Font color="black" size={18} />
      </Tooltip>
      <Size height={500} />
    </Chart>
  );
};

export default BarChartKPI;
